import { Pipe, PipeTransform } from '@angular/core';

/**
 * FilterBy Pipe
 * Filters an array of objects by a specified property value.
 * 
 * Usage: *ngFor="let item of items | filterBy:'property':'value'"
 * 
 * Example: *ngFor="let line of groupedFormLines | filterBy:'IS_DISPLAY':'Y'"
 */
@Pipe({
    name: 'filterBy',
    pure: false,
    standalone: false
})
export class FilterByPipe implements PipeTransform {

  transform(items: any[], property: string, value: any): any[] {
    if (!items || !property) {
      return items;
    }

    return items.filter(item => item[property] === value);
  }
}
